import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import { ACCESS_TYPE, AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';
import { transformError } from 'utils/utils';
import store from '../store';

const unauthorizedCode = [401, 403];

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
});

const TOKEN_PAYLOAD_KEY = 'Authorization';

let hasShownAuthError = false;

service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN) || null;

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`;
    }

    return config;
  },
  (error) => {
    notification.error({
      message: 'Request Error',
      key: 'request-error',
    });
    return Promise.reject(error);
  },
);

service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status;

    if (unauthorizedCode.includes(status)) {
      if (!hasShownAuthError) {
        notification.error({
          message: 'Authentication Fail',
          key: 'auth-error',
        });

        const keys = [ACCESS_TYPE, AUTH_TOKEN];
        keys.forEach((key) => localStorage.removeItem(key));
        store.dispatch(signOutSuccess());

        hasShownAuthError = true;

        // Reset the flag after some time to allow future notifications
        setTimeout(() => {
          hasShownAuthError = false;
        }, 3000);
      }
    }

    // Handle 404 Not Found
    if (status === 404) {
      notification.error({
        message: 'API Not Found',
        key: 'not-found',
      });
    }

    // Handle 500 Internal Server Error
    if (status === 500) {
      notification.error({
        message: 'Internal Server Error',
        key: 'server-error',
      });
    }

    // Handle 508 Timeout
    if (status === 508) {
      notification.error({
        message: 'Time Out',
        key: 'timeout-error',
      });
    }

    const err = transformError(error);
    return Promise.reject(err);
  },
);

export default service;
